import { batchService, studentService } from '../services';
import {
  parseStudentList,
  getStudentTrade,
  normalizeTradeCode,
  isSecondaryStudent,
  studentMatchesTrades,
  mergeStudentsById,
  getBatchIdFromStudent,
} from './instructorScope';

export const getTradeFromRecord = (record) => {
  if (!record) return '';
  const fromStudent = record.student && typeof record.student === 'object'
    ? getStudentTrade(record.student)
    : '';
  return String(record.trade || record.fieldOfStudy || fromStudent || '').trim();
};

export const recordMatchesScope = (record, { batchId, trade, date } = {}) => {
  const rDate = record.date ? new Date(record.date).toISOString().split('T')[0] : '';
  if (date && rDate !== date) return false;

  if (batchId) {
    const rBatch = record.batch?._id || record.batch;
    if (rBatch && String(rBatch) !== String(batchId)) return false;
  }

  if (trade) {
    const recordTrade = normalizeTradeCode(getTradeFromRecord(record));
    const scopeTrade = normalizeTradeCode(trade);
    if (recordTrade && scopeTrade && recordTrade !== scopeTrade) return false;
  }

  return true;
};

export const ATTENDANCE_LEVEL_OPTIONS = ['Level 3', 'Level 4', 'Level 5', 'Other'];

export const getStudentLevel = (student) =>
  String(student?.level || '').trim();

export const studentMatchesLevel = (student, levelFilter = '') => {
  if (!levelFilter) return true;
  return getStudentLevel(student).toLowerCase() === String(levelFilter).trim().toLowerCase();
};

export const recordMatchesLevel = (record, levelFilter = '') => {
  if (!levelFilter) return true;
  const student = record?.student && typeof record.student === 'object' ? record.student : null;
  if (!student) return true;
  return studentMatchesLevel(student, levelFilter);
};

export const studentsToRoll = (students) =>
  (Array.isArray(students) ? students : [])
    .map((s) => ({
      studentId: s._id,
      fullName: s.fullName || 'Unknown',
      trade: getStudentTrade(s) || '—',
      level: getStudentLevel(s) || '—',
    }))
    .sort((a, b) => a.fullName.localeCompare(b.fullName, undefined, { sensitivity: 'base' }));

export const loadBatchStudentsByTrade = async (batchId, tradeFilter = '', levelFilter = '') => {
  if (!batchId) return [];

  let students = [];
  try {
    const fromBatch = await batchService.getBatchStudents(batchId);
    students = mergeStudentsById(students, parseStudentList(fromBatch));
  } catch {
    /* batch endpoint may be unavailable */
  }

  if (students.length === 0) {
    try {
      const all = await studentService.getAllStudents();
      students = parseStudentList(all)
        .filter(isSecondaryStudent)
        .filter((s) => String(getBatchIdFromStudent(s)) === String(batchId));
    } catch {
      /* ignore */
    }
  }

  students = students.filter(isSecondaryStudent);

  if (tradeFilter) {
    students = students.filter((s) => studentMatchesTrades(s, [tradeFilter]));
  }
  if (levelFilter) {
    students = students.filter((s) => studentMatchesLevel(s, levelFilter));
  }

  return students;
};

export const filterRunningSecondaryBatches = (batches) => {
  const list = Array.isArray(batches) ? batches : [];
  return list.filter((b) => {
    const track = String(b.track || 'secondary').toLowerCase();
    const status = String(b.status || '').toLowerCase();
    return track === 'secondary' && (status === 'running' || status === 'open');
  });
};
